import script from "./CartComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CartComponent.vue?vue&type=style&index=0&id=73fe9872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fe9872"]])

export default __exports__